<div class="box__scroll" id="box__scroll">
  <app-caricamento-vini *ngIf="loading"></app-caricamento-vini>
  <!-- <app-caricamento *ngIf="loading"></app-caricamento> -->
  <div
    *ngIf="checkAbilitato && abilitato && abilitatoVenditaVino && !loading"
    class="w-100 flex-items"
  >
    <app-vini-base
      [vini]="viniFiltered"
      [pacchetti]="pacchetti"
      [linguaCorrente]="linguaCorrente"
      [codiceForm]="codiceForm"
      *ngIf="layout == 1"
      (filtraPacchetti)="filtraPacchetti($event)"
      (selezionaVino)="selezionaVino($event)"
    ></app-vini-base>
    <app-vini-vendibili-layout-colonne
      [vini]="viniFiltered"
      [pacchetti]="pacchetti"
      [linguaCorrente]="linguaCorrente"
      [codiceForm]="codiceForm"
      *ngIf="layout == 2"
      (filtraPacchetti)="filtraPacchetti($event)"
      (selezionaVinoEmit)="selezionaVino($event)"
    ></app-vini-vendibili-layout-colonne>
    <app-pacchetti-vendibili-layout-base
      [pacchetti]="pacchettiFiltered"
      [linguaCorrente]="linguaCorrente"
      [codiceForm]="codiceForm"
      (selezionaPacchetto)="selezionaPacchetto($event)"
      [isFiltrati]="isFiltrati"
    ></app-pacchetti-vendibili-layout-base>
    <app-nessun-risultato
      [tipologia]="'vini'"
      *ngIf="viniFiltered.length == 0 && pacchettiFiltered.length == 0"
    ></app-nessun-risultato>
  </div>
  <div *ngIf="checkAbilitato && !abilitato && abilitatoVenditaVino && !loading">
    <app-disabilitato [pagina]="'wineshop'"></app-disabilitato>
  </div>
</div>
